module.exports = __webpack_public_path__ + "static/media/googleLogo.1b03449e.png";